<!-- @format -->

<div class="ssg-name">
  <div class="fudis-heading__xxs sis-mt-xs">{{ studySubGroup.name | localizedString: language }}</div>
  @if (studySubGroup.cancelled) {
    <sis-tiny-badge [variant]="'danger'">
      {{ "STUDY_SUB_GROUP_EVENT_INFO.CANCELLED" | translate }}
    </sis-tiny-badge>
  }
</div>
@if ($sortedStudyEvents | async; as sortedStudyEvents) {
  @if (sortedStudyEvents?.length > 0) {
    @for (studyEvent of sortedStudyEvents; track studyEvent) {
      <div class="study-sub-group-info time-series-border">
        <app-student-study-event-structure [studyEvent]="studyEvent" [teacherIds]="studySubGroup.teacherIds" [language]="language">
        </app-student-study-event-structure>
      </div>
    }
  } @else {
    <div class="no-events sis-mb-sm">
      {{ "SIS_COMPONENTS.COURSE_UNIT_REALISATION_STRUCTURE.NO_STUDY_EVENT" | translate }}
    </div>
  }
}
